import React from "react";
import { Link } from "gatsby";

export const menues = [
  {
    name: "コンサルティングサービス",
    href: "#consulting",
  },
  {
    name: "スポットサービス",
    href: "#spot",
  },
  {
    name: "秘書役サービス（営業許可・ビザ申請包括請負いサービス）",
    href: "#registration",
  },
];

const ServiceMenu = () => {
  return (
    <div className="bg-gray-100 text-gray-600 font-sans text-sm tracking-wide">
      <div className="container mx-auto max-w-4xl py-3 flex md:justify-around flex-col md:flex-row text-center gap-2 md:gap-0">
        {menues.map((menu, index) => (
          <Link
            key={index}
            to={`${menu.href}`}
            activeClassName="text-cyan-600"
            className="hover:text-blue-500"
          >
            {menu.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ServiceMenu;
